exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/* explorer */\n/* actionbar */\n@font-face {\n  font-family: 'cat';\n  src: url(\"/assets/fonts/cat.eot?vcfb5d\");\n  src: url(\"/assets/fonts/cat.eot?vcfb5d#iefix\") format(\"embedded-opentype\"), url(\"/assets/fonts/cat.ttf?vcfb5d\") format(\"truetype\"), url(\"/assets/fonts/cat.woff?vcfb5d\") format(\"woff\"), url(\"/assets/fonts/cat.svg?vcfb5d#cat\") format(\"svg\");\n  font-weight: normal;\n  font-style: normal; }\n\n:host ::ng-deep .ui-chkbox {\n  padding-left: 5px; }\n\n:host ::ng-deep .ui-chkbox-label {\n  padding-top: 8px;\n  padding-right: 15px;\n  font-weight: normal; }\n\n:host ::ng-deep .ui-button-text {\n  padding-top: 5px; }\n\n:host ::ng-deep .ui-widget-header {\n  background: transparent;\n  border: 0px;\n  padding: 5px 0px 5px 4px; }\n\n:host ::ng-deep .colspan-header {\n  padding: 10px;\n  font-weight: bold; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /agent/workspace/CUS-LHT_NICE_nto_nto_CAT_release@2/app/Resources/Public/src/app/modules/models/test-rack/components/test-rack-unit-assignment/test-rack-unit-assignment.component.scss
// module id = ../../../../../src/app/modules/models/test-rack/components/test-rack-unit-assignment/test-rack-unit-assignment.component.scss
// module chunks = main